(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
class HeroSlideshow {
  constructor(element) {
    this.hero          = element;
    this.slides        = Array.from(this.hero.querySelectorAll('.hero__slide'));
    this.dots          = Array.from(this.hero.querySelectorAll('.hero__nav-dot'));
    this.prevBtn       = this.hero.querySelector('.hero__arrow--prev');
    this.nextBtn       = this.hero.querySelector('.hero__arrow--next');
    this.currentSlide  = 0;
    this.autoplay      = this.hero.dataset.autoplay === 'true';
    this.speed         = (parseInt(this.hero.dataset.speed, 10) || 5) * 1000;
    this.autoplayTimer = null;
    this.init();
  }

  init() {
    if (this.slides.length <= 1) return;

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goToSlide(i)));
    this.prevBtn?.addEventListener('click', (e) => { e.preventDefault(); this.prevSlide(); });
    this.nextBtn?.addEventListener('click', (e) => { e.preventDefault(); this.nextSlide(); });

    this.hero.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  this.prevSlide();
      if (e.key === 'ArrowRight') this.nextSlide();
    });

    if (this.autoplay) {
      this.startAutoplay();
      this.hero.addEventListener('mouseenter', () => this.stopAutoplay());
      this.hero.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }

  goToSlide(index) {
    this.slides[this.currentSlide].classList.remove('hero__slide--active');
    this.dots[this.currentSlide]?.classList.remove('hero__nav-dot--active');
    this.currentSlide = index;
    this.slides[this.currentSlide].classList.add('hero__slide--active');
    this.dots[this.currentSlide]?.classList.add('hero__nav-dot--active');
    if (this.autoplay) { this.stopAutoplay(); this.startAutoplay(); }
  }

  nextSlide() { this.goToSlide((this.currentSlide + 1) % this.slides.length); }
  prevSlide()  { this.goToSlide((this.currentSlide - 1 + this.slides.length) % this.slides.length); }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.nextSlide(), this.speed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) { clearInterval(this.autoplayTimer); this.autoplayTimer = null; }
  }

  reinit() {
    this.stopAutoplay();
    this.slides       = Array.from(this.hero.querySelectorAll('.hero__slide'));
    this.dots         = Array.from(this.hero.querySelectorAll('.hero__nav-dot'));
    this.currentSlide = 0;
    this.slides.forEach((s, i) => s.classList.toggle('hero__slide--active', i === 0));
    this.dots.forEach((d, i)   => d.classList.toggle('hero__nav-dot--active', i === 0));
    this.init();
  }
}

const _heroSlideshows = new Map();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-slideshow="true"]').forEach((el) => {
    _heroSlideshows.set(el.id, new HeroSlideshow(el));
  });
});

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-slideshow="true"]');
    if (el) _heroSlideshows.set(el.id, new HeroSlideshow(el));
  });

  document.addEventListener('shopify:block:select', (e) => {
    const section = e.target.closest('[data-slideshow="true"]');
    if (!section) return;
    const sw = _heroSlideshows.get(section.id);
    if (!sw) return;
    const idx = sw.slides.indexOf(e.target);
    if (idx >= 0) { sw.stopAutoplay(); sw.goToSlide(idx); }
  });

  ['shopify:block:deselect', 'shopify:block:reorder'].forEach((evt) => {
    document.addEventListener(evt, (e) => {
      const section = e.target.closest('[data-slideshow="true"]');
      if (section) _heroSlideshows.get(section.id)?.reinit();
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
